import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import { CustomerAdminService } from '../../customer-admin.service';
import * as CompanyInfoActions from './company-info.actions';

@Injectable()
export class CompanyInfoEffects {
    constructor(
        private actions$: Actions,
        private service: CustomerAdminService
    ) {}

    post$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CompanyInfoActions.getCompanyInfo),
            switchMap(a =>
                this.service.get(a.customerid, a.IsInternal).pipe(
                    flatMap(resp => [
                        CompanyInfoActions.loadCompanyInfos({
                            CompanyInfos: JSON.parse(resp)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    put$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CompanyInfoActions.putCompanyInfo),
            switchMap(a =>
                this.service.put(a.JsonString).pipe(
                    flatMap(c => [
                        CompanyInfoActions.upsertCompanyInfos({
                            CompanyInfos: JSON.parse(c)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
